import CssBaseline from "@mui/material/CssBaseline";
import Home from "./Home";
import React from "react";
import SailInfo from "./SailInfo/SailInfo";
import ServiceLofts from "./Service/ServiceLofts";
import { BrowserRouter, Route, Routes } from "react-router";

export default function App() {
    return (
        <>
            <CssBaseline />
            <BrowserRouter>
                <Routes>
                    <Route element={<Home />} path="/" />
                    <Route element={<Home />} path="/home" />
                    <Route element={<ServiceLofts />} path="/servicelofts" />
                    <Route element={<SailInfo />} path="/sailinfo/:guid" />
                </Routes>
            </BrowserRouter>
        </>
    );
}
